// First-party event contract. Default is denied; never include free text or URLs with queries.
import { captureApprovedEvent } from './consent-analytics';
const names = new Set(['view_product', 'select_configuration', 'download_technical_file', 'start_comparison', 'submit_project_enquiry', 'request_sample']);
const keys = new Set(['product_id', 'model_code', 'configuration_code', 'file_revision', 'file_type', 'page_type']);
const delivered = new Set();
export function specificationEvent(name, properties = {}, dedupeKey) {
  try {
    if (!names.has(name) || localStorage.getItem('lb_analytics_consent') !== 'granted') return;
    if (dedupeKey && delivered.has(`${name}:${dedupeKey}`)) return;
    const safe = Object.fromEntries(Object.entries(properties).filter(([k, v]) => keys.has(k) && ['string', 'number'].includes(typeof v)));
    if (captureApprovedEvent(name, safe) && dedupeKey) delivered.add(`${name}:${dedupeKey}`);
  } catch { /* Analytics must never interrupt specification. */ }
}